import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberWithCommas',
})
export class NumberWithCommasPipe implements PipeTransform {
  transform(value: number | string): string {
    if(value==0)
      return '0';
    if (!value) return '';
    const num = typeof value === 'number' ? value : parseFloat(value);
    return num.toLocaleString(); // Automatically formats with commas
  }
}
